module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DanKNc/tc-custom/9781504096607.jpg?1726483131857",
      "alt": "This image is the cover for the book Second Chances at the Little Love Café"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Second Chances at the Little Love Café\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the author of "), _c('i', [_vm._v("The Car Share")]), _vm._v(": Her broken heart is bad for business—but can a partnership with her first love save the day?")]), _c('br'), _c('br'), _vm._v(" If she’s honest, Alice has stopped believing in the power of love. . . . Finding your fiancé in bed with a woman he met during his bachelor party will do that."), _c('br'), _c('br'), _vm._v(" So, when Alice’s first love, Noah—the one who got away—reappears in her seaside hometown after more than twenty years, the cynical single mom doesn’t know how to feel."), _c('br'), _c('br'), _vm._v(" However, when Alice and Noah are left in charge of The Little Love Café while the owner goes abroad, her jaded attitude has a negative effect on the business. And soon, the #heartbreakcafe threatens to start trending."), _c('br'), _c('br'), _vm._v(" She’s on a sure path to self-destruction, a family feud is brewing, and the café is in peril. Can anyone help them turn things around? Or is The Little Love Café doomed to close its doors for a final time?"), _c('br'), _c('br'), _c('b', [_vm._v("Praise for Lucy Mitchell")]), _c('br'), _c('br'), _vm._v(" “[Mitchell’s] writing is deliciously funny and has so much heart.” —Sandy Barker, author of "), _c('i', [_vm._v("One Summer in Santorini")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucy Mitchell\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0